"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _UserMenu = require("./UserMenu.style");

var _AvatarImage = _interopRequireDefault(require("../../AvatarImage"));

var _Link = _interopRequireDefault(require("../../Link"));

var _Dropdown = _interopRequireDefault(require("../../Dropdown"));

var _NavItem = _interopRequireDefault(require("../../NavItem"));

var UserMenu = function UserMenu(_ref) {
  var activeItem = _ref.activeItem,
      avatar = _ref.avatar,
      menu = _ref.menu,
      onItemClick = _ref.onItemClick,
      onItemHoverEnd = _ref.onItemHoverEnd,
      onItemHoverStart = _ref.onItemHoverStart,
      rest = _objectWithoutProperties(_ref, ["activeItem", "avatar", "menu", "onItemClick", "onItemHoverEnd", "onItemHoverStart"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      colors = _ref2.colors,
      nav = _ref2.nav; // This is used to handle the active state of the dropdown


  var menuLabel = 'Avatar';
  var hasMenu = menu && menu.length > 0;
  var avatarWrapperAnimations = {
    rest: {
      border: "0.2rem solid ".concat(colors.primary)
    },
    hover: {
      border: "0.2rem solid ".concat(colors[nav.accentColor])
    }
  };
  return /*#__PURE__*/_react.default.createElement(_UserMenu.Wrapper, Object.assign({}, rest, {
    onClick: function onClick() {
      return onItemHoverStart(menuLabel);
    },
    onHoverEnd: function onHoverEnd() {
      return onItemHoverEnd(menuLabel);
    },
    onHoverStart: function onHoverStart() {
      return onItemHoverStart(menuLabel);
    }
  }), /*#__PURE__*/_react.default.createElement(_UserMenu.AvatarWrapper, {
    whileHover: "hover",
    variants: avatarWrapperAnimations,
    initial: "rest"
  }, /*#__PURE__*/_react.default.createElement(_AvatarImage.default, Object.assign({
    size: "small"
  }, avatar))), hasMenu && /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    isOpened: activeItem === menuLabel,
    direction: "right",
    width: "20rem"
  }, menu.map(function (menuItem) {
    var handleClick = function handleClick(e) {
      e.stopPropagation();
      onItemClick(e);
      return menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick(e);
    };

    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      key: menuItem.label,
      to: menuItem.url,
      onClick: handleClick
    }, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
      description: menuItem.description,
      label: menuItem.label
    }));
  })));
};

UserMenu.propTypes = {
  activeItem: _propTypes.default.string,
  avatar: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string
  }),
  menu: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  onItemClick: _propTypes.default.func,
  onItemHoverEnd: _propTypes.default.func,
  onItemHoverStart: _propTypes.default.func,
  pathname: _propTypes.default.string
};
UserMenu.defaultProps = {
  activeItem: null,
  avatar: {},
  menu: [],
  onItemClick: function onItemClick() {},
  onItemHoverEnd: function onItemHoverEnd() {},
  onItemHoverStart: function onItemHoverStart() {},
  pathname: ''
};
var _default = UserMenu;
exports.default = _default;